import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { faqList } from '@/mocks/mikami/faq';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqList[0]?.id ?? '');

  return (
    <section id="faq" className="anchor-offset bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="常见问题"
          title="浏览前你可能想问的"
          description="下面整理了与本页内容相关的常见问题，涵盖分区作用、信息核对方式与浏览体验等方面。点击问题即可展开查看解答。"
        />

        <div className="max-w-3xl space-y-3">
          {faqList.map((item) => {
            const isOpen = item.id === openId;
            return (
              <div key={item.id} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? '' : item.id)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/50"
                >
                  <span className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-label text-primary-700">
                      Q
                    </span>
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                  </span>
                  <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg text-foreground-600`}></i>
                </button>
                {isOpen && (
                  <p className="border-t border-background-200 px-5 py-4 pl-14 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}